import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { resolveAttendanceReport } from 'features/attendance/attendanceSlice'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'

export const ResolveModal = ({ closeModal, id }) => {
  const [state, setState] = useState({
    resolutionStatus: null,
    comment: '',
  })

  const dispatch = useDispatch<AppDispatch>()

  const handleSave = async () => {
    const resp = await dispatch(resolveAttendanceReport({ ...state, id }))
    if (resp.meta.requestStatus === 'fulfilled') {
      closeModal()
    }
  }

  return (
    <Modal black>
      <Flex column gap='3rem' center>
        <Flex column between center gap='1rem' width='100%'>
          <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
            <TitleText weight='bold'>Resolve Report</TitleText>
            <CursorPointer onClick={closeModal}>
              <CloseIcon />
            </CursorPointer>
          </Flex>

          <Flex between gap='1rem' width='100%' column>
            <HonestSelectInput
              nomarg
              labelText='Resolution Status'
              onChange={(v) => setState((prev) => ({ ...prev, resolutionStatus: v }))}
              options={[
                { label: 'Approved', value: 1 },
                { label: 'Rejected', value: 2 },
              ]}
            />
            <Input
              type='textarea'
              minHeight='150px'
              placeholder='Enter comment'
              onChange={(e) => setState((prev) => ({ ...prev, comment: e.target.value }))}
              nomarg
              name='comment'
              labelText='Comment'
              value={state.comment}
            />
          </Flex>
        </Flex>

        <Button disabled={!state.resolutionStatus?.value} orange onClick={handleSave}>
          Save
        </Button>
      </Flex>
    </Modal>
  )
}
